export default "__VITE_ASSET__BmWob7qK__"